import { UIComponentViewImpl } from '../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler, UIComponentState } from '../../../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { BlackListRowComponentProps, BlackListRowComponentHandler } from './blacklistrowcomponent';
import * as React from 'react';
import { BlackListRowCSSStyle } from './blacklistrowcss';

export class BlackListRowViewImpl extends UIComponentViewImpl<UIDataModel>
{
  
    bindHandlers()
    {
        this.onDeleteClick = this.onDeleteClick.bind(this);
    }
   constructor(context: BaseContext, handler: UIComponentHandler)
   {
       super(context, handler);

      
   }

    draw(props: BlackListRowComponentProps, state: UIComponentState, cssStyle: BlackListRowCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
          <tr style={cssStyle.getWrapperCSSStyle()}>
              <td style={cssStyle.getBlacklistNameDivCSSStyle()}>
                  <label style={cssStyle.getBlacklistNameLabelCSSStyle()}>
                    {props.blacklistDto.getMemberName()}
                  </label>
                  <label style={cssStyle.getMSISDNLabelCSSStyle()}>
                    {props.blacklistDto.getMsisdn()}
                  </label>
              </td>
             
              <td onClick={this.onDeleteClick} style={cssStyle.getDeleteImgDivCSSStyle()}>
                    <img style={cssStyle.getDeleteImgCSSStyle()} width='20px' height='20px' src={this.getContext().getResources().getImage("delete_trash.svg")}/>
              </td>
              
          </tr>    
         
        );
    }
    
  onDeleteClick():void
  {
     (this.getUIComponentHandler() as BlackListRowComponentHandler).onDeleteClick();
  }
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/viewmodel/blacklistrowview.tsx